import React from "react"
import { useStaticQuery, graphql } from "gatsby"

const HomeCTA = () => {
  const data = useStaticQuery(graphql`
    query {
      wpContentSettings(id: { eq: "cG9zdDoyMQ==" }) {
        home {
          bottomCtaContent
          bottomCtaLink {
            title
            url
          }
        }
      }
    }
  `)

  const { bottomCtaContent, bottomCtaLink } = data.wpContentSettings?.home

  return (
    <div
      className="wrapper image-wrapper bg-auto no-overlay bg-image text-center bg-map"
      style={{ backgroundImage: "url(/img/map.png)" }}
    >
      <div className="container py-md-8">
        <div className="row">
          <div className="col-xl-11 col-xxl-9 mx-auto">
            <h3 className="display-4 mb-8 px-lg-8">{bottomCtaContent}</h3>
          </div>

          <div className="d-flex justify-content-center">
            <span>
              <a
                href={bottomCtaLink.url}
                className="btn btn-primary rounded-pill"
              >
                {bottomCtaLink.title}
              </a>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeCTA
